import { Theme } from "@material-ui/core";

export default {
    palette: {
        primary: {
          light: '#33c9dc',
          main: '#095c9e',
          dark: '#008394',
          contrastText: '#fff'
        },
        secondary: {
          light: '#ff6333',
          main: '#ff3d00',
          dark: '#b22a00',
          contrastText: '#fff'
        }
      },
      direction: 'rtl',
      spreatIt:{

      }
} 